import * as types from './types';
import {
  ToolBookStatementCollegeTotalModel,
  ToolBookStatementDetailModel
} from 'src/model/AdminModel';

export default{

  actionToolBookStatementCollegeTotalModel({state,commit},query){
    if (state.bookStatementCollegeTotalModel.state === 'loading') {
      return Promise.reject();
    }
    commit(types.ACTION_TOOL_BOOK_STATEMENT_COLLEGE_TOTAL_DETAIL, {
      state: 'loading'
    });
    return ToolBookStatementCollegeTotalModel.getInstance().execute(query).then((response) => {
      commit(types.ACTION_TOOL_BOOK_STATEMENT_COLLEGE_TOTAL_DETAIL, {
        ...response,
        state: 'loadend'
      });
      return response;
    }).catch((err) => {
      commit(types.ACTION_TOOL_BOOK_STATEMENT_COLLEGE_TOTAL_DETAIL, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },

  actionToolBookStatementDetailModel({state,commit},query){
    if (state.bookStatementDetailModel.state === 'loading') {
      return Promise.reject();
    }
    commit(types.ACTION_TOOL_BOOK_STATEMENT_DETAIL_MODEL, {
      state: 'loading'
    });
    return ToolBookStatementDetailModel.getInstance().execute(query).then((response) => {
      commit(types.ACTION_TOOL_BOOK_STATEMENT_DETAIL_MODEL, {
        ...response,
        state: 'loadend'
      });
      return response;
    }).catch((err) => {
      commit(types.ACTION_TOOL_BOOK_STATEMENT_DETAIL_MODEL, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },

}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/settlementMoney/actions.js